import moment from "moment-timezone";
import React, { useContext } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import { useNavigate } from "react-router-dom";

function OnHoldTable({ data }) {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const navigate = useNavigate();

  const contractStatusType = {
    0: {
      title: t("Created"),
      class: "text-gray bg-soft-secondary",
      contractClass: "text-gray",
    },
    1: {
      title: t("Waiting Acceptance"),
      class: "text-warning bg-softer-warning",
      contractClass: "text-warning",
    },
    2: {
      title: t("Declined"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    3: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    4: {
      title: t("In Progress"),
      class: "text-primary bg-soft-primary",
      contractClass: "text-primary",
    },
    5: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    6: {
      title: t("Approved"),
      class: "text-info bg-soft-primary",
      contractClass: "text-info",
    },
    7: {
      title: t("Rejected"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    8: {
      title: t("Declined"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    9: {
      title: t("Completed"),
      class: "text-success bg-soft-success",
      contractClass: "text-success",
    },
    10: {
      title: t("Deleted"),
      class: "text-muted bg-soft-danger",
      contractClass: "text-muted",
    },
    11: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    12: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
  };

  const localizeDate = (date) => {
    const localizeDateText = moment(date).format("MMM DD, YYYY");
    const mappings = {
      Jan: t("Jan"),
      Feb: t("Feb"),
      Mar: t("Mar"),
      Apr: t("Apr"),
      May: t("May"),
      Jun: t("Jun"),
      Jul: t("Jul"),
      Aug: t("Aug"),
      Sep: t("Sep"),
      Oct: t("Oct"),
      Nov: t("Nov"),
      Dec: t("Dec"),
    };

    return localizeDateText
      .split(" ")
      .map((word) => mappings[word] || word)
      .join(" ");
  };

  const linkTypesItems = {
    1: t("Do Follow"),
    2: t("No Follow"),
    3: t("Sponsored"),
  };

  const linkTypesItemsStyles = {
    [t("Do Follow")]: "text-primary",
    [t("No Follow")]: "",
    [t("Sponsored")]: "custom-text-gray",
  };

  const placementItems = {
    1: t("Guest Post"),
    2: t("Link Insert"),
    3: t("Niche Edit"),
  };

  const navigateToOpenDetails = (uuid) => {
    navigate(`/contracts/${uuid}`);
  };

  return (
    <div
      className={`table-responsive datatable-custom ${themeStatus?.[selectedTheme]}`}
    >
      <table
        className="table table-thead-bordered table-nowrap card-table "
        style={{ border: "transparent" }}
      >
        <thead className="thead-light">
          <tr>
            <th className={`table-column-ps-2`}>{t("CONTRACT")}</th>
            <th>{t("CREATED")}</th>
            <th>{t("PLACEMENT")}</th>
            <th>{t("LINK TYPE")}</th>
            <th>{t("TIME LEFT")}</th>
            <th>{t("PRICE")}</th>
          </tr>
        </thead>

        <tbody>
          {!!data?.length ? (
            data?.map((item, index) => {
              const now = moment();
              const end = moment(item?.moneyback_policy_ends);
              const duration = moment.duration(end.diff(now));

              const daysLeft = Math.max(duration.asDays(), 0);
              const totalDays = 365;

              const percentage = Math.max(
                100 - (daysLeft / totalDays) * 100,
                0
              );

              return (
                <React.Fragment key={index}>
                  <tr className="align-middle">
                    <td className="ps-md-3">
                      <div
                        className={`${
                          contractStatusType[item?.status]?.contractClass
                        } responsive-text-onHold text-decoration-underline cursor-pointer`}
                        onClick={() => navigateToOpenDetails(item?.uuid)}
                      >
                        {item?.code}
                      </div>
                    </td>
                    <td className="ps-md-3">
                      <div className="custom-text-gray responsive-text-onHold">
                        {localizeDate(item?.created)}
                      </div>
                    </td>
                    <td className="align-middle pt-3">
                      <div className="custom-text-gray responsive-text-onHold">
                        {placementItems[item?.type]}
                      </div>
                    </td>

                    <td className="align-middle pt-3">
                      <div
                        className={`responsive-text-onHold ${
                          linkTypesItemsStyles[linkTypesItems[item?.rel]]
                        }`}
                      >
                        {item?.links} · {linkTypesItems[item?.rel]}
                      </div>
                    </td>
                    <td className="align-middle pt-3">
                      <div
                        className="progress-on-hold"
                        style={{
                          padding: "2px",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "5px",
                          backgroundColor: "transparent",
                          position: "relative",
                        }}
                      >
                        <div
                          className="progress"
                          style={{
                            height: "18px",
                            width: "100%",
                            borderRadius: "3px",
                            backgroundColor: "var(--progress-remaining)",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <div
                            className="progress-bar bg-primary"
                            role="progressbar"
                            style={{
                              width: `${percentage}%`,
                              height: "100%",
                              borderRadius: "3px 0 0 3px",
                              transition: "width 0.4s ease",
                            }}
                            aria-valuenow={percentage}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          />
                          <span
                            className="text-start ps-0"
                            style={{
                              color: "var(--days-left)",
                              position: "absolute",
                              top: "50%",
                              left: "10px",
                              transform: "translateY(-50%)",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            {daysLeft > 0
                              ? `${Math.floor(daysLeft)} ${t(
                                  daysLeft === 1 ? "day left" : "days left"
                                )}`
                              : `0 ${t("days left")}`}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div
                        className="text-white responsive-text-onHold"
                        style={{ fontWeight: "700" }}
                      >
                        ${item?.price}
                      </div>
                    </td>
                  </tr>

                  {index !== data?.length - 1 && (
                    <tr>
                      <td
                        colSpan="100%"
                        className="px-3 py-0"
                        style={{ border: "transparent" }}
                      >
                        <div
                          style={{
                            width: "calc(100% - 2px)",
                            height: "2px",
                            backgroundColor:
                              selectedTheme === "dark"
                                ? "rgba(45, 50, 54, 1)"
                                : "rgba(45, 50, 54, 0.2)",
                            margin: "0 auto",
                          }}
                        />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="100%">
                <div
                  className="text-center p-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="dark"
                  />
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="default"
                  />
                  <p className="mb-0">
                    {!data ? t("Loading data") : t("No data to show")}
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default OnHoldTable;
